import React from 'react';

import { createLocale } from 'locales';

import Typography from 'components/typography/typography';

import { useOrganisationJobDetail } from 'state/context/organization/OrganisationJobDetail';

import Link from 'components/link/link';

import Pairtext from '../pairtext';

const localize = createLocale('organizationPlannerJobDetailsLocales');

const Invoice: React.FC = () => {
  const {
    jobContext: { data: job },
  } = useOrganisationJobDetail();
  return (
    <div className="bg-white border-gray200/50 border-2 w-full h-fit pt-4 px-6 pb-8 font-roboto flex flex-col flex-wrap gap-5 rounded-md">
      <div className="w-full flex justify-between">
        <Typography variant="body-large-bold" as="p">
          {localize('invoice')}
        </Typography>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3  lg:grid-cols-6 gap-5">
        <Pairtext
          Title={localize('invoiceDate')}
          Value={job.invoice.invoice_date}
        />
        <Pairtext Title={localize('hours')} Value={job.hours} />
        <Pairtext
          Title={localize('totalAmountTaxExcluded')}
          Value={`€${job.invoice.invoice_vat}`}
        />
        <Pairtext
          Title={localize('hoursCheckedBy')}
          Value={job.organisation.name}
        />
        <Pairtext Title={localize('status')} Value="Betaald" />
      </div>

      <Link
        variant="outlined"
        label={localize('downloadInvoice')}
        iconProps={{ icon: 'download' }}
        className="w-fit"
        href={job.invoice.file}
        target="_blank"
      />
    </div>
  );
};

export default Invoice;
